export const getAncestorTags = (tag, contentTagsMapById, includeSelf) => {
  const results = [];
  let currentTag = includeSelf ? tag : contentTagsMapById[tag?.parentId];

  while (currentTag) {
    results.push(currentTag);
    currentTag = contentTagsMapById[currentTag.parentId];
  }

  return results.reverse();
};
